import olMap from 'ol/Map';
import { MapBrowserEvent } from "ol";
import { Coordinate } from "ol/coordinate";
import { MapHighlightFeatures } from "../MapHighlightFeatures";
import { MapFeatureInfo } from "../MapfeatureInfo";

/**
 * Owns the WMS feature-info click flow: member/anonymous prompts, highlight,
 * popup comment counts. The window["routeids"]-style globals populated by the
 * server-rendered popup HTML are confined to this module.
 * TODO: the globals originate in the server popup template — removing them
 * needs a server-side change.
 */
export class FeatureInfoController {

    private _mapHighlight: MapHighlightFeatures;
    private _mapFeatureInfo: MapFeatureInfo;
    private _enabled: boolean = true;
    private _preClickHandler: ((evt: MapBrowserEvent) => boolean) | null = null;

    public constructor(
        private _map: olMap,
        wmsUrl: string,
        infoClickProw: number,
        private _isAuthenticated: boolean,
        private _isMember: boolean,
        private _loginUrl: string,
        private _registerUrl: string,
        private _siteId: string
    ) {
        this._mapHighlight = new MapHighlightFeatures(this._map, wmsUrl);
        this._mapFeatureInfo = new MapFeatureInfo(this._mapHighlight, infoClickProw === 1);

        this._map.on("singleclick", this.handleClick);
    }

    get highlight(): MapHighlightFeatures {
        return this._mapHighlight;
    }

    /** Gates the singleclick feature-info flow (e.g. off while measuring/editing). */
    public setEnabled = (enabled: boolean): void => {
        this._enabled = enabled;
    }

    /**
     * Registers a handler that gets first refusal on map clicks (e.g. GPX
     * waypoint markers). Returning true consumes the click and skips the WMS
     * feature-info query.
     */
    public setPreClickHandler = (handler: (evt: MapBrowserEvent) => boolean): void => {
        this._preClickHandler = handler;
    }

    public closePopup = (): void => {
        this._mapFeatureInfo.closePopup();
    }

    public showFeaturesAtCoordinate = (coordinate: Coordinate): void => {
        this.resetFeatureInfoState();
        this._mapFeatureInfo.showFeaturesAtCoordinate(this._map, coordinate, () => this.onFeatureInfoLoaded(null));
    }

    public showFeatureInfoForLayer = (coordinate: Coordinate, layerName: string): void => {
        if (!coordinate || !layerName) {
            return;
        }
        this._mapFeatureInfo.showFeatureInfoForLayers(this._map, coordinate, [layerName], function () { });
    }

    public highlightRouteGuids = (routeGuids: string[]): void => {
        this._mapHighlight.highlightFeaturesAtEvent(null, routeGuids, [], []);
    }

    private handleClick = (evt: MapBrowserEvent): void => {
        let self = this;
        let html: string = "";
        if (!this._enabled) {
            //nothing to do
            return;
        }

        if (this._preClickHandler && this._preClickHandler(evt)) {
            //consumed (e.g. a waypoint marker was clicked)
            return;
        }

        //show message for unauthenticated / non-member users
        if (self._isMember === false) {
            html = self._isAuthenticated === false
                ? self.htmlForLoginRegisterPrompt()
                : self.htmlForNonMemberPrompt();
            self._mapFeatureInfo.showHtmlAtCoordinate(self._map, evt.coordinate, html);
            return;
        }

        this.resetFeatureInfoState();
        self._mapFeatureInfo.showFeaturesAtEvent(self._map, evt, () => self.onFeatureInfoLoaded(evt));
    }

    private resetFeatureInfoState = (): void => {
        window["routeids"] = [];
        window["prowcodes"] = [];
        window["legacyrouteids"] = [];
        window["landregistryids"] = [];
    }

    private onFeatureInfoLoaded = (evt: MapBrowserEvent | null): void => {
        this._mapHighlight.highlightFeaturesAtEvent(evt, window["routeids"], window["legacyrouteids"], window["landregistryids"]);

        //once the popup html is in place we can get the comment counts
        this.loadPopupCommentCounts();
    }

    private loadPopupCommentCounts = (): void => {
        let self = this;
        $(".talkabout-comment-count").each(function (ele, i) {
            let countEle = $(this);
            let threadId = countEle.data("talkaboutThreadid");

            countEle.load(`/api/talk/CommentCount?projectid=${self._siteId}&threadid=${threadId}`, function (result) {
                var count = parseInt(result);
                if (!isNaN(count) && count > 0) {
                    countEle.text(`${count} comment(s)`);
                }
                else {
                    countEle.text('');
                }
            });
        });
    }

    private htmlForLoginRegisterPrompt = (): string => {
        let htmlContent = `<div class='small incidentPopupRow'>
                         Please <a href='${this._loginUrl}'>Login</a> or <a href='${this._registerUrl}'>Register</a> to see route details.  <a href='/registering-with-trailwise'>Find out more...</a>
                       </div>`;

        return htmlContent;
    }

    private htmlForNonMemberPrompt = (): string => {
        let htmlContent = `<div class='small incidentPopupRow'>
                         If you have lost the ability to use all features of TW2 your GLASS membership has likely expired.
                       </div>`;

        return htmlContent;
    }
}
